import { z } from 'zod';
export const AchievementTypeAndIdParamsSchema = z.object({
    type: z.enum(['projects', 'awards', 'conferences', 'bibliography']),
    id: z
        .any()
        .optional()
        .refine((value) => {
        if (typeof value === 'string') {
            return !isNaN(parseInt(value));
        }
        return typeof value === 'number';
    })
});
//# sourceMappingURL=achievementTypeAndIdParamsSchema.js.map